<template>
     <b-modal
          id="taskModal"
          ref="taskModal"
          :title="popupTitle"
          size="xl"
          :hide-footer="true"
          @cancel="resetModal"
          @close="resetModal"

     >
          <b-container class="modal-body-lg">
               
               <TaskEntryForm
                    :task="task"
                    :enableControls="true"
                    @cancelled:task="resetModal()"
                    @action:complete="handleActionComplete"/>

          </b-container>
     </b-modal>
</template>

<script>
import genericOps from '../mixins/genericOps'
import TaskEntryForm from '@/components/blocks/TaskEntryForm.vue'
import taskOps from '../mixins/taskOps'


export default {
     name: 'CreateTaskPopup',
     components: {
          TaskEntryForm
     },
     mixins: [taskOps, genericOps],
     props: {
          task: {
               type: Object,
               default: {
                    ...taskOps.emptyTask,
                    parentTask: {...taskOps.emptyTask},
               },
          },
     },
     data() {
          return {
               dateFormatOptions: { year: 'numeric', month: 'numeric', day: '2-digit',  },
               hasError: false,
               resultMessage: '',
          }
     },
     mounted() {},
     watch: {
          task: function(newVal) {
               ////console.log('CreateTaskPopup.watch.task has task = ' + JSON.stringify(newVal))
          },
     },
     computed: {
          parentTask: function() {
               return ((this.task || {}).parentTask || {})
          },
          parentTitle: function() {
               // 20260203 -- Copilot (Claude Haiku 4.5) -- Added null check for empty parentTask
               // WHY: When parentTask is null or empty object, .title is undefined/null
               if (typeof this.parentTask != 'undefined' && this.parentTask !== null && typeof this.parentTask.title != 'undefined' && this.parentTask.title !== null) {
                    return this.parentTask.title
               } else {
                    return null
               }
          },
          popupTitle: function() {
               if (typeof this.parentTitle != 'undefined' && this.parentTitle !== null) {
                    return 'Create Sub-task of ' + this.parentTitle
               } else {
                    return 'Create Task'
               }
          },
     },
     methods: {
          // 20260126 -- Copilot (Claude Sonnet 4.5) -- Handle action completion
          // WHY: Control modal behavior based on action type without duplicate save processing
          // NOTE: saveTask2 already handled saving and adding to store
          // UPDATED: 20260127 -- Emit event to parent to reset task for proper reactivity
          // 20260203 -- Copilot (Claude Haiku 4.5) -- Added support for 'close' action
          // WHY: 'Add & Close' button uses 'close' action to close modal after saving
          async handleActionComplete(action) {
               if (action === 'new' || action === 'similar') {
                    // Keep modal open for both "Add & Create New" and "Add & Create Similar"
                    await this.$nextTick()
                    
                    // Emit event to parent (AppLayout) to reset/clear task
                    this.$emit('reset:task', action)
                    
                    // Focus on title field
                    await this.$nextTick()
                    await this.$nextTick() // Extra tick to ensure reactivity completes
                    const titleInput = document.getElementById('title')
                    if (titleInput) {
                         titleInput.focus()
                    }
               } else {
                    // Close modal for all other actions (including 'close')
                    await this.$nextTick()
                    this.resetModal()
               }
          },
          resetModal(bvModalEvt) {
               // 20260127 -- Copilot (Claude Sonnet 4.5) -- Reset task to empty when modal closes
               // WHY: Prevent old task data from appearing when modal is reopened
               // UPDATED: 20260127 -- Clear all keys first, then assign emptyTask to ensure clean slate
               Object.keys(this.task).forEach(key => {
                    this.$delete(this.task, key)
               })
               Object.keys(this.emptyTask).forEach(key => {
                    this.$set(this.task, key, this.emptyTask[key])
               })
               
               this.taskValidation = {}

               try {
                    this.$nextTick(() => {
                         this.$bvModal.hide('taskModal')
                    })
               } catch(error) {
                    // Intentionally left blank.
                    // Modal may not exist on the UI.
               }
          },
     },
}
</script>

<style scoped></style>
